<!--
세금계산서 업데이트
------------------------------------
-->
<template>
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-large">

            <div class="uk-modal-header">
                <h4>세금계산서 수정</h4>
            </div>
            <div class="uk-modal-body uk-padding-small app-table-normal">

                <table class="uk-table uk-table-small uk-table-middle">
                    <colgroup>
                        <col style="width: 120px">
                        <col>
                    </colgroup>

                    <tbody>
                    <tr>
                        <th class="uk-text-center">
                            회원사
                        </th>
                        <td>
                            {{ invoice.user_nick }}
                        </td>
                    </tr>
                    <tr>
                        <th class="uk-text-center">
                            상호
                        </th>
                        <td>
                            {{ invoice.company_name }}
                            <div v-if="invoice.company_name !== company.name" class="uk-text-muted">{{ company.name }}</div>
                        </td>
                    </tr>
                    <tr>
                        <th class="uk-text-center">
                            발행일
                        </th>
                        <td>
                            {{ invoice.issue_date ? invoice.issue_date.format('YYYY-MM-DD') : null }}
                        </td>
                    </tr>
                    <tr>
                        <th class="uk-text-center">
                            발행여부
                        </th>
                        <td>

                            <app-input-select
                                input-size="medium"

                                v-model="inputs.issue"
                                :options="issueOptions"

                                required-layout="label-left"
                            > </app-input-select>

                            <div class="uk-margin-top">
                                * 현재 선택된 세금계산서의 발행여부만 변경됩니다.
                            </div>
                            <div>
                                * 해당 업체의 세금계산서 발행여부를 영구적으로 변경하려면 <span class="uk-text-bold">총괄관리 > 회원관리</span>에서 수정해야 합니다.
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>



            </div>


            <div class="uk-modal-footer uk-text-right">
                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-default uk-modal-close"
                >
                    <span uk-icon="icon: close"></span> 취소
                </button>
                <button
                    type="button"
                    class="uk-button uk-button-primary"
                    v-on:click="submit()"
                >
                    <span uk-icon="icon: check"></span>
                    저장
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            // csrf-token
            csrfToken: String,
        },
        data: function () {
            return {
                // 입력값 object
                inputs: {
                    issue: null,
                },

                // 발행여부 옵션배열
                issueOptions: [],

                // 계산서
                invoice: {},

                // 사업자정보
                company: {},
            };
        },
        computed: {
        },
        methods: {
            /**
             * 입력폼 display
             */
            displayForm() {
                UIkit.modal(this.$el).show();
            },

            /**
             * 폼
             * @param invoice_id 세금계산서 ID
             */
            form(invoice_id) {

                // promise 생성
                let load = new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'get',
                        url: '/tax-invoices/' + invoice_id,
                        contentType: 'application/json',
                        data: {},
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                load.then((response) => {
                    // 계산서정보
                    let invoice = response.invoice
                    invoice.issue_date = moment(invoice.issue_date, "YYYY-MM-DD hh:mm:ss");
                    this.invoice = invoice;
                    this.company = response.company;


                    // 입력값 설정
                    _.assignIn(this.inputs, {
                        issue: this.invoice.issue
                    });


                    // 옵션배열 저장
                    this.issueOptions = response.issue_options;

                    // 폼띄우기
                    this.displayForm();
                });
            },

            /**
             * submit
             */
            submit() {

                // ajax 옵션
                let opts = {
                    type: 'patch',
                    url: '/tax-invoices/' + this.invoice.id,
                    data: _.merge({
                        '_token': this.csrfToken,
                    }, this.inputs),
                    success: (response, textStatus, jqXHR) => {
                        UIkit.modal.alert(response.msg).then(function () {
                            $.app.refresh();
                        });
                    },
                };

                // ajax 실행
                $.app.ajax.module.default(opts);
            },
        },
    }
</script>

<style lang="scss" scoped>
</style>